import * as React from "react";
import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import VideoThumbnail from "react-video-thumbnail";
import axios from 'axios';
interface props {
  rtb: {
    CampaignID: number;
    bidID: number;
    bid_price: number;
    videourl: string;
    urlredirect: string;
  };
  ap: any;
  passPortal: any;
  deviceId: string;
  band: any;
  search: string;
  userData: any;
  threshold: number;
  skip_seconds: number;
  each_seconds: number;
  location: any;
  survey_ids: any;
  token: any;
}

export const RTBVideoBanner: FC<props> = ({
  rtb,
  ap,
  passPortal,
  deviceId,
  band,
  survey_ids,
  search,
  token,
  threshold,
  skip_seconds,
  each_seconds,
  userData,
}) => {
  const [thumnai, setThumnai] = useState("");
  
  const _postImpressionRTBVideo = async (
    mediaType: string,
  ) => {
    try {
      const fields = {
        AccessPointID: ap.ap_mac,
        LocationID: Number(ap.ap_locationid),
        DeviceID:deviceId,
        CampaignID: rtb.CampaignID,
        MediaType: mediaType,
      };
      await axios.post("/impressions", { fields });
    
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <h5
        style={{
          textAlign: "center",
          marginBottom: "20px",
          color: "#DD4641",
        }}
      >
        ¡WiFi Gratis! 20 Minutos
      </h5>
      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
        }}
      >
        <div
          style={{
            textAlign: "center",
          }}
        ></div>
        <div className="row w-100 m-0">
          <Link
            className="col-11 card m-0  flex-row  align-items-center"
            style={{
              boxShadow: "0px 6px 26px 1px rgba(0,0,0,0.13)",
              color: "black",
              height: "6.8em",
              //backgroundImage: `url(/google-storage/${encodeURIComponent(rtb.videourl)})`,
              backgroundImage: `url(${thumnai})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
            onClick={() => _postImpressionRTBVideo(`rtb-${rtb.bidID}`) }
            to={{
              pathname: "/content",
              campaign: {
                CampaignID: rtb.CampaignID,
                CampaignVideoURL: rtb.videourl,
                RedirectURL: rtb.urlredirect,
                RedirectURL_iphone: rtb.urlredirect
              },
              DeviceID: deviceId,
              ap,
              band,
              survey_ids,
              search: search,
              token: token,
              threshold,
              userData,
              skip_seconds,
              each_seconds,
            }}
          ></Link>
          <div className="d-none">
            <VideoThumbnail
              videoUrl={rtb.videourl.includes("storage.googleapis") ? `/google-storage/${encodeURIComponent(rtb.videourl)}` : rtb.videourl}
              thumbnailHandler={(thumbnail) => setThumnai(thumbnail)}
              width={0}
              height={0}
              snapshotAtTime={10}
            />
          </div>
          <div className="col-1 m-0 p-0">
            <button
              className="btn btn-lg btn-danger w-100"
              style={{
                height: "100%",
                textAlign: "center",
                padding: 0,
                borderRadius: "0px 20px 20px 0px",
              }}
            >
              &raquo;
            </button>
          </div>
        </div>
      </div>
      <h5
        style={{
          textAlign: "center",
          marginTop: "20px",
          color: "#DD4641",
        }}
      >
        ¡Dale click a una promoción para WiFi!
      </h5>
    </>
  );
};
